'use client';

import { type DragEvent, useRef, useState } from 'react';

export function useWorkspaceUploadDrop(
  onFiles: (files: File[]) => void,
  disabled = false
) {
  const depth = useRef(0);
  const [active, setActive] = useState(false);

  return {
    'data-workspace-upload-drop': '',
    'data-drag-active': active && !disabled,
    onDragEnter(event: DragEvent<HTMLElement>) {
      if (disabled || !Array.from(event.dataTransfer.types).includes('Files'))
        return;
      event.preventDefault();
      event.stopPropagation();
      depth.current += 1;
      setActive(true);
    },
    onDragOver(event: DragEvent<HTMLElement>) {
      event.preventDefault();
      event.stopPropagation();
    },
    onDragLeave(event: DragEvent<HTMLElement>) {
      event.stopPropagation();
      depth.current = Math.max(0, depth.current - 1);
      if (depth.current === 0) setActive(false);
    },
    onDrop(event: DragEvent<HTMLElement>) {
      event.preventDefault();
      event.stopPropagation();
      depth.current = 0;
      setActive(false);
      if (!disabled) onFiles(Array.from(event.dataTransfer.files ?? []));
    },
  };
}
